/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Resource/Form
 * @desc Filter Resource form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import { PostFilterExperimentWorkflowResource } from 'labstep-web/services/postFilter/filters/experiment-workflow-resource';
import { PostFilterExperimentWorkflowResourceItem } from 'labstep-web/services/postFilter/filters/experiment-workflow-resource-item';
import React from 'react';
import type { IFilterPostNewIndexResourceFormProps } from './types';

const FilterPostNewIndexResourceForm: React.FC<
  IFilterPostNewIndexResourceFormProps
> = ({ addPostFilter, onDone, activeGroup }) => {
  const [selectedResource, setSelectedResource] =
    React.useState<Resource | null>(null);

  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={Resource.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
        }}
        onChange={(selectedOption) => {
          if (addPostFilter) {
            addPostFilter(
              PostFilterExperimentWorkflowResource.getNode([
                selectedOption?.guid,
              ]),
            );
          }
          setSelectedResource(selectedOption);
        }}
      />
      <br />
      <b>Specific item used</b>
      <br />
      {!selectedResource && <p>Select a resource above first</p>}
      {selectedResource && (
        <SearchSelect
          entityName={ResourceItem.entityName}
          isClearable
          params={{
            resource_id: selectedResource.guid,
          }}
          onChange={(selectedOption) => {
            if (addPostFilter) {
              addPostFilter(
                PostFilterExperimentWorkflowResourceItem.getNode([
                  selectedOption?.guid,
                ]),
              );
            }
            onDone();
          }}
        />
      )}
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostNewIndexResourceForm);
